import React, { useContext } from 'react'
import { SelectDomain } from '../SelectDomain'
import { CreateDomain } from '../CreateDomain'
import useAnalytics from '@/hooks/useAnalytics'
import {
  ANALYTICS,
  ECP_EXPERIENCE,
  PRODUCT_FAMILY_LFP
} from '@/store/Constants'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { ConfigContext } from '@/store'

const { SCREENS, MODES, LINKS } = ANALYTICS

export function DomainRegistrationSection({
  pageData,
  retry,
  doDomainsExist,
  setSelectedOrganization,
  selectedOrganization,
  selectedCountry,
  setSelectedCountry,
  availableOrganizations,
  enteredOrganization,
  organizationEntryHandler,
  countrySelectorHandler,
  isOrganizationNameValid,
  hpPlusCountrySelected,
  supportedCountriesClickHandler
}) {
  const { experience, sessionContext } = useContext(ConfigContext)
  const { omfeReleaseShowAiTou: showAiTou } = useFlags()
  const { fireHyperLinkClick } = useAnalytics(SCREENS.COMPANY_NAME)

  const termsOfUseClickHandler = (e) => {
    const closestAnchor = e.target.closest('a')
    if (!closestAnchor || !e.currentTarget.contains(closestAnchor)) return

    const link = closestAnchor.href.includes('admin-tou')
      ? LINKS.TOU
      : LINKS.AI_TOU
    fireHyperLinkClick(link, {
      mode: MODES.DOMAIN[doDomainsExist]
    })
  }

  const agreementText = () => {
    const isNewOrg = !doDomainsExist || selectedOrganization === 'new'
    const flowWithAiTou =
      experience !== ECP_EXPERIENCE &&
      sessionContext?.onboardingContext?.productFamily !== PRODUCT_FAMILY_LFP
    const shouldShowAiTou =
      selectedCountry === 'US' && flowWithAiTou && showAiTou

    if (!isNewOrg)
      return selectedOrganization && shouldShowAiTou
        ? pageData.agree_terms_ai_only
        : ''
    return shouldShowAiTou ? pageData.agree_terms_with_ai : pageData.agree_terms
  }

  return (
    <>
      {doDomainsExist && (
        <SelectDomain
          pageData={pageData}
          retry={retry}
          setSelectedOrganization={setSelectedOrganization}
          availableOrganizations={availableOrganizations}
          selectedOrganization={selectedOrganization}
        />
      )}
      {(!doDomainsExist || selectedOrganization === 'new') && (
        <CreateDomain
          pageData={pageData}
          enteredOrganization={enteredOrganization}
          organizationEntryHandler={organizationEntryHandler}
          retry={retry}
          isOrganizationNameValid={isOrganizationNameValid}
          hpPlusCountrySelected={hpPlusCountrySelected}
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
          countrySelectorHandler={countrySelectorHandler}
          supportedCountriesClickHandler={supportedCountriesClickHandler}
          doDomainsExist={doDomainsExist}
        />
      )}
      <p
        data-testid="assign-org-tou"
        onClick={termsOfUseClickHandler}
        dangerouslySetInnerHTML={{
          __html: agreementText()
        }}
      />
    </>
  )
}
